import { useEffect, useState, useCallback } from 'react'
import { useSessionContext } from '../contexts/SessionContext'
import { getUserExpAccessCodes } from '../utils/helpers/supabase.helpers'
import { AccessCode } from '../types/supabase'

interface UseExperiencesAccessCodesOptions {
  enabled?: boolean
}

interface UseExperiencesAccessCodesReturn {
  accessCodesList: AccessCode[] | null
  isLoading: boolean
  refetch: () => Promise<void>
}

export const useExperiencesAccessCodes = (
  options: UseExperiencesAccessCodesOptions = {}
): UseExperiencesAccessCodesReturn => {
  const { user } = useSessionContext()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [accessCodesList, setAccessCodesList] = useState<AccessCode[] | null>(null)
  const { enabled = true } = options

  const fetchAccessCodesList = useCallback(async (): Promise<void> => {
    if (enabled === false) {
      return
    }

    const { data, error } = await getUserExpAccessCodes({ userId: user!.id })

    if (error || !data) {
      setIsLoading(false)
      return
    }

    setAccessCodesList(data)
    setIsLoading(false)
  }, [user, enabled])

  useEffect(() => {
    if (!user || enabled === false) {
      return
    }

    fetchAccessCodesList()
  }, [user, enabled, fetchAccessCodesList])

  return { accessCodesList, isLoading, refetch: fetchAccessCodesList }
}
